import createFiniquito from './createFiniquito'
import updateFiniquito from './updateFiniquito'
import fetchById from './fetchById'
import decideAction from './dicideAction'
import deleteFiniquito from './deleteFiniquito'
export default {
    createFiniquito,
    updateFiniquito,
    fetchById,
    decideAction,
    deleteFiniquito,
}
